import React from "react";
const Config = {
  url: window.location.origin,
  userName: "",
  passWord: "",
};

if (ReactIsInDevelomentMode()) {
  console.log("~~~ DEV MODE ~~~");
  Config.url = "";
  Config.userName = "jds";
  Config.passWord = "jdsadmin1234";
}

export default Config;

function ReactIsInDevelomentMode() {
  return "_self" in React.createElement("div");
}
